const { scrollmagic } = require("./modules/scrollmagic");
const { pageTop } = require("./modules/pageTop");
const { smooth } = require("./modules/smooth");
const { hamburger } = require("./modules/hamburger");

scrollmagic();
pageTop();
smooth();
hamburger();